import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { listDepartmentsWithRelationsQuery } from '@/queries/department.query'
import { DepartmentService } from '@/services/department.service'
import { DotsHorizontalIcon } from '@radix-ui/react-icons'
import { IconTrash } from '@tabler/icons-react'
import { useQueryClient } from '@tanstack/react-query'
import { Row } from '@tanstack/react-table'
import { toast } from 'sonner'
import { useDepartments } from '../context/departments-context'
import { departmentSchema } from '../schema'


interface DataTableRowActionsProps<TData> {
  row: Row<TData>
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const department = departmentSchema.parse(row.original)
  const queryClient = useQueryClient()
  const { setOpen, setCurrentRow } = useDepartments()

  async function handleAssignAsDefault() {
    if (department.isDefault) {
      toast.warning(`O departamento ${department.name} já é padrão.`);
      return;
    }

    toast.promise(DepartmentService.assignAsDefault(department.id), {
      loading: `Atribuindo como padrão o departamento ${department.name}...`,
      success: () => {
        queryClient.invalidateQueries(listDepartmentsWithRelationsQuery)
        return `Departamento ${department.name} atribuído como padrão.`;
      },
      error: () => {
        queryClient.invalidateQueries(listDepartmentsWithRelationsQuery)
        return `Erro ao atribuir como padrão o departamento ${department.name}.`;
      },
    })
  }

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant='ghost'
          className='flex h-8 w-8 p-0 data-[state=open]:bg-muted'
        >
          <DotsHorizontalIcon className='h-4 w-4' />
          <span className='sr-only'>Abrir menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-[160px]'>
        <DropdownMenuItem
          onClick={() => {
            setCurrentRow(department)
            setOpen('update')
          }}
        >
          Editar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleAssignAsDefault}>
          Atribuir como Padrão
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            setCurrentRow(department)
            setOpen('delete')
          }}
        >
          Remover
          <DropdownMenuShortcut>
            <IconTrash size={16} />
          </DropdownMenuShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
